import { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import companyUserApi from "../../../api/companyUsers";

const DeleteCompanyModal = ({ show, onClose, company, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (company) {
      fetchCompanyUsers(company.id);
    }
  }, [company]);

  const fetchCompanyUsers = async (companyId) => {
    try {
      setLoading(true);
      const response = await companyUserApi.getUserByCompanyId(companyId);
      setUsers(response.data || []);
    } catch (error) {
      console.error("Error fetching company users:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = () => {
    onConfirm({ reason, newAdmin: selectedAdmin });
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Company</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Why do you want to delete this company?</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Assign a new admin (optional)</Form.Label>
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : users.length > 0 ? (
              <Form.Select
                value={selectedAdmin}
                onChange={(e) => setSelectedAdmin(e.target.value)}
              >
                <option value="">-- No admin assigned --</option>
                {users.map((user) => (
                  <option key={user.id} value={user.userEmail}>
                    {user.userName} ({user.userEmail})
                  </option>
                ))}
              </Form.Select>
            ) : (
              <p>No users available in this company</p>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          Delete Company
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteCompanyModal;
